// src/awsConfig.ts
const awsConfig = {
    region: process.env.REACT_APP_AWS_REGION as string,
    UserPoolId: process.env.REACT_APP_AWS_USER_POOL_ID as string,
    ClientId: process.env.REACT_APP_AWS_CLIENT_ID as string,
};

export default awsConfig;
